class ProgramType {
  // init method gets the details of the cell to be renderer
  init(params) {
    this.eGui = document.createElement("div");
    this.eGui.className = "statusCell";
    let status;
    if (params.value === 1) {
      status = "Prepaid";
    } else {
      status = "Credit";
    }
    if (params.value !== "") this.eGui.innerHTML = `${status}`;
    let style = `<style>
         .statusCell{
          display:flex;
          line-height:1
         }
      </style>`;
    this.eGui.innerHTML += style;
  }
  getGui() {
    return this.eGui;
  }

  refresh(params) {
    return false;
  }
}

export default ProgramType;
